const state = {
    maskerShow:false//控制发布弹窗的展示和关闭  消除路由缓存影响
}

const mutations = {
    showMasker(state){
        state.maskerShow=true;
    },
    closeMasker(state){
        state.maskerShow=false;
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/masker.js